import { render } from "./ManageInstances.vue?vue&type=template&id=6cddc49e&scoped=true"
import script from "./ManageInstances.vue?vue&type=script&lang=js"
export * from "./ManageInstances.vue?vue&type=script&lang=js"

import "./ManageInstances.vue?vue&type=style&index=0&id=6cddc49e&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cddc49e"]])

export default __exports__